import { DRAW_MODAL } from 'src/reducers/modal/types';
import { QUICK_SHARE_SET, QUICK_SHARE_STOP } from 'src/reducers/user/types';

import { urls } from 'Utilities/dataHelpers';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import { store } from 'Utilities/store';

import { STOP_QUICK_SHARE_MODAL } from 'Constants/modalTypes';

function isQuickShare(value: unknown): value is QuickShare {
  return (value as QuickShare).code !== undefined && (value as QuickShare).expiresAt !== undefined;
}

const handleStopSharing = (request: any) => {
  request.response = new Promise((resolve, reject) => {
    const { code } = request;

    mediator
      .request('api:invoke', {
        method: 'DELETE',
        url: `${urls.lslApi}sharing/quick-share/${code}`,
      })
      .then((result) => {
        if (result.status === 0) {
          store.dispatch({ type: QUICK_SHARE_STOP, code });
          resolve(result);
          return;
        }

        mediator.publish('error:display', {
          error: {
            code: result.status,
            type: 'ERROR_STOP_QUICK_SHARE',
          },
        });
        reject(result);
      })
      .catch((err) => {
        mediator.publish('error:display', {
          error: {
            code: err.status,
            type: 'ERROR_STOP_QUICK_SHARE',
          },
        });
        reject(err);
      });
  });
};

const handleGenerateCode = (request: any) => {
  request.response = new Promise((resolve, reject) => {
    mediator
      .request('api:invoke', {
        method: 'POST',
        url: `${urls.lslApi}sharing/quick-share`,
      })
      .then((result) => {
        if (result.status === 0 && isQuickShare(result.data)) {
          store.dispatch({
            type: QUICK_SHARE_SET,
            quickShare: result.data,
          });

          resolve(result);

          return;
        }

        throw result;
      })
      .catch((err) => {
        mediator.publish('error:display', {
          error: {
            code: err.status,
            type: 'ERROR_GENERATE_QUICK_SHARE_CODE',
          },
          onDismiss: () => mediator.publish('router:redirect', '/'),
          errorMessage: i18n.t('QuickShare.quickShareError'),
        });
        reject(err);
      });
  });
};

const handleStopQuickShareModal = ({
  callback,
  code,
}: {
  callback: (r: LVApiResponse) => void;
  code: string;
}) => {
  store.dispatch({
    type: DRAW_MODAL,
    modal: STOP_QUICK_SHARE_MODAL,
    props: { callback, code },
  });
};

mediator.subscribe('quickShare:generateCode', handleGenerateCode);
mediator.subscribe('quickShare:stopSharing', handleStopSharing);
mediator.subscribe('quickShare:stopSharingModal', handleStopQuickShareModal);
